import React from "react";
import {FormattedMessage} from "react-intl";

class SendEmailCellEditor extends React.Component {
  render() {
    return (
      <div className={'tsk-input-line'}>
        <p>
          <FormattedMessage
            id={'cell.send_email.description'}
            defaultMessage={'Send email form cell. Users can enter their email and accept terms to receive an email. No configuration needed.'}
          />
        </p>
      </div>
    );
  }
}

export default SendEmailCellEditor;
